import axios from 'axios';

export default {
  vacaciones: [],
  periodosVac: [],
  errorMessage: '',

  // Valida que aun no tenga derecho a vacaciones en el periodo indicado.
  validaSinDiasPeriodo(ejercicio, periodo) {
    let ok = true;
    const perVac = this.periodosVac.find(pv => pv.ejercicio == ejercicio);
    if (perVac) {
      if (periodo == 1) {
        ok = perVac.diasPer1 === 0;
      } else {
        ok = perVac.diasPer2 === 0;
      }
      if (!ok) {
        this.errorMessage = "Este empleado ya tiene derecho a vacaciones. Realice el registro de manera normal."
      }
    }
    return ok;
  },

  // Valida que no se registren mas de 10 días en un periodo.
  validDias(ejercicio, periodo, dias) {
    const diasDisf = this.vacaciones
      .filter(v => v.ejercicio === ejercicio && v.periodo === periodo && v.idEstatusJustificante <= 4)
      .reduce((total, dias) => total += dias, 0);
    let error = false;
    if (diasDisf+ dias > 10) {
      error = true;
      this.errorMessage = "Se excede de 10 días en el periodo.";
    }
    return error;
  },

  async loadPeriodosVac(numEmpleado, modo) {
    const response = await axios.get(`/justificante/vacaciones/${numEmpleado}?modo=${modo}`);
    this.vacaciones = response.data.vacaciones;
    this.periodosVac = response.data.periodos;
  },

  async saveVacaciones(justiDto, vacDto, ejercicio) {
    const rsp = await axios.get(`/vacaciones/periodovac/${justiDto.numEmpleado}?ejercicio=${ejercicio}`);
    vacDto.idPeriodoVacaciones = rsp.data.idPeriodoVacaciones;
    const data = {
      justificante: justiDto,
      justiVac: vacDto
    }
    const strDat = JSON.stringify(data);
    const response = await axios.post(`/justificante/vacaciones/adelanta?modo=private`, strDat);
    return response;
  },

  tieneAccesoInfEmpleado(numEmpleado) {
    return axios.get(`/empleado/acceso/${numEmpleado}`);
  },

  getPeriodoVac(numEmpleado, ejercicio) {
    return axios.get(`/vacaciones/periodovac/${numEmpleado}?ejercicio=${ejercicio}`);
  }
}